import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';

type ViewProps = {
  btnSubmit?: boolean
  onPrevious?: () => void
  onNext: ( values:any ) => void
  previousText?: string
  nextText?: string
  showNextIcon?: boolean
  showPrevIcon?: boolean
  disabledNext?: boolean
};

function LinkInvitationFooter( {
  btnSubmit, onPrevious, onNext, previousText, nextText,
  showNextIcon = true,
  showPrevIcon = true,
  disabledNext = false,
}: ViewProps ) {
  return (
    <Row className="footer">
      <Col>
        {onPrevious && (
        <Button
          variant="light"
          onClick={onPrevious}
        >
          {showPrevIcon && <i className="icon-arrow-prev me-1" />}
          {previousText || 'Anterior'}
        </Button>
        )}
      </Col>
      <Col className="text-end">
        <Button
          variant="primary"
          onClick={onNext}
          type={btnSubmit ? 'submit' : 'button'}
          disabled={disabledNext}

        >
          {nextText || 'Siguiente'}
          {showNextIcon && ( <i className="icon-arrow-forward ms-1 text--xs" /> )}
        </Button>
      </Col>
    </Row>
  );
}

export default LinkInvitationFooter;
